<template>
  <div class="activities-tiles">
    <div class="row" style="margin-bottom: 15px">
      <div class="col-12">
        <button v-on:click="setIdIcon(false)" class="btn btn-secondary">
          Toon alle kinderen
        </button>
        Filter:
        <span v-if="icons">
          <span v-bind:key="activityIcon.id" v-for="activityIcon in filterIcons(icons)" v-on:click="setIdIcon(activityIcon.icon_id)">
            <activity-icon :id="activityIcon.icon_id" :height="'45px'" style="margin: 10px"></activity-icon>
          </span>
        </span>
      </div>
    </div>
    <div v-if="sortChildren(filter(children)).length > 0" class="row">
      <div v-bind:key="child.id" v-for="child in sortChildren(filter(children))" class="col-12 col-sm-4 col-lg-3 row-eq-height">
        <child-list-item :child="child" @editActivity="editActivity($event)" class="item"/>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-12">
        <br>
        <p class="text-center">Geen kinderen met deze activiteit</p>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityIcon from '@/components/Activity-Icon'
import ChildListItem from '@/components/Child-List-Item'
export default {
  name: 'activities-tiles',
  components: {
    ActivityIcon,
    ChildListItem
  },
  created () {
    this.$store.dispatch('getChildren')
    this.$store.dispatch('getChildrenPresence')
    this.$store.dispatch('getGroupActivityTypes')
  },
  computed: {
    icons () {
      return this.getActivityTypeIcons()
    },
    activityTypes () {
      return this.$store.getters.groupActivityTypes
    }
  },
  data () {
    return {
      filter_by_id_icon: false
    }
  },
  methods: {
    setIdIcon (idIcon) {
      this.filter_by_id_icon = idIcon
    },
    filterIcons (icons) {
      var filteredIcons = []
      var activities = this.activityTypes.filter(function (el) {
        return el.enter_time_end === true
      })
      var idIcons = activities.map(function (el) {
        return el.icon_id
      })
      // Remove duplicate values
      idIcons = idIcons.filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
      idIcons.map(function (idIcon) {
        var addIcon = icons.filter(function (icon) {
          return parseInt(icon.icon_id) === parseInt(idIcon)
        })
        if (addIcon.length > 0) {
          filteredIcons.push(addIcon[0])
        }
      })
      return filteredIcons
    },
    filter (children) {
      if (this.filter_by_id_icon === false) {
        return children
      }
      var filteredChildren = []
      for (var i = 0; i < children.length; i++) {
        if (!children[i].status) {
          continue
        }
        if (!children[i].status.activities) {
          continue
        }
        if (children[i].status.activities.length < 1) {
          continue
        }
        for (var a = 0; a < children[i].status.activities.length; a++) {
          if (parseInt(children[i].status.activities[a].icon_id) === parseInt(this.filter_by_id_icon)) {
            filteredChildren.push(children[i])
          }
        }
      }
      return filteredChildren
    },
    sort (children, by) {
      by = by || this.getApplicationSetting('ipad_sort_children_by')
      if (by === false) {
        by = 'first_name'
      }
      return this.$lodash().sortBy(children, [child => child[by].toLowerCase()], 'asc')
    },
    editActivity (activity) {
      this.$emit('openModalWithActivity', activity)
    }
  }
}
</script>

<style scoped>
  .item {
    background: rgba(255, 255, 255, 0.5);
    background: white;
    border: none;
    padding: 20px;
    height: 100%;
  }
  .row-eq-height {
    margin-bottom: 15px;
  }
  @media (min-width: 62em) {
    .card-columns {
      -webkit-column-count: 4;
      -moz-column-count: 4;
      column-count: 4;
    }
  }
</style>
